export const CUSTOM_PAGE_CONSTS = {
    GET_CUSTOM_PAGES: "GET_CUSTOM_PAGES",
    CREATE_CUSTOM_PAGE: "CREATE_CUSTOM_PAGE",
    UPDATE_CUSTOM_PAGE: "UPDATE_CUSTOM_PAGE",
    DELETE_CUSTOM_PAGE_BY_ID: "DELETE_CUSTOM_PAGE_BY_ID",
};
